<button (click)="downloadTemplate()" class="download-template-btn">Download Template</button>
